import { useDeviceType } from '@cian/ui-kit';
import { Sravnenie16 } from '@cian/ui-kit/prev/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackingCompareIconClick } from './tracking';
import { Utility } from '../../components/Utility';
import { Utility as UtilityRedesign } from '../../components/Utility/Redesign';
import { selectIsExperimentGroupNameB } from '../../selectors/experiments/myHomeRedesign';

export const UtilityCompareContainer: React.FC = () => {
  const deviceType = useDeviceType();
  const handleClick = React.useCallback(trackingCompareIconClick, []);

  // TODO: После завершения эксперимента выпилить ненужное
  const isExperimentGroupB = useSelector(selectIsExperimentGroupNameB);

  if (deviceType === 'phone') {
    return null;
  }

  if (isExperimentGroupB) {
    return (
      <UtilityRedesign
        data-name="UtilityCompareContainer"
        title="Сравнение"
        icon={Sravnenie16}
        href="/compare/"
        onClick={handleClick}
      />
    );
  }

  return (
    <Utility
      data-name="UtilityCompareContainer"
      title="Сравнение объектов"
      icon={Sravnenie16}
      href="/compare/"
      onClick={handleClick}
    />
  );
};
